export const INITIAL_ROLES_SEARCH_PARAMS = {
  page: 1,
  id: '',
  name: '',
  type: '',
  limit: 300,
  sort_method: 'desc',
  order_by: 'id',
}

export const INITIAL_ROLE = {
  id: null,
  name: '',
  type: 1,
  permissions: [],
}

export const INITIAL_RESET = {
  selectAll: false,
  unselectAll: false,
}

export const ROLE_TYPE = {
  INTERNAL: 1,
  EXTERNAL: 2,
}
